export default __webpack_public_path__ + "static/media/2.3ce51c9b.png";